import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Hero from './components/Hero';
import BrandDefinition from './components/BrandDefinition';
import GuideCards from './components/GuideCards';
import Gallery from './components/Gallery';
import GuideDetails from './components/GuideDetails';
import Investment from './components/Investment';
import TourSection from './components/TourSection';
import FAQSection from './components/FAQSection';
import QuickSummary from './components/QuickSummary';
import FooterCTA from './components/FooterCTA';

function Home() {
  return (
    <Layout>
      <Hero />
      <BrandDefinition />
      <GuideCards />
      <Gallery />
      <GuideDetails />
      <Investment />
      <TourSection />
      <FAQSection />
      <QuickSummary />
      <FooterCTA />
    </Layout>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;